import React, { useState, useContext, useEffect, useRef } from "react";
import { logAnalyticsEvent } from "../firebase/firebaseConfig";
import { useNavigate } from "react-router-dom";
import "../styles/global.css";
import { UserContext } from "../context/UserContext";
import { EnvContext } from "../context/EnvContext";

import MenuDrawerHeader from "./_menuDrawer/menuDrawerHeader";
import MyAccountComponent from "./_menuDrawer/myAccountComponent";
import LoginComponent from "./_menuDrawer/loginComponent";

import { ArrowForward, KeyboardArrowUpOutlined, KeyboardArrowDownOutlined } from "@mui/icons-material";
import FindYourVibe from "../elements/FindYourVibe";
import CategoryBrowse from "../elements/CategoryBrowse";

export const MenuDrawer = ({ isOpen, toggleMenu }) => {
  const environment = useContext(EnvContext);
  const navigate = useNavigate();
  const drawerRef = useRef(null);

  const [toggleCategory, setToggleCategory] = useState(false);
  const [toggleEffect, setToggleEffect] = useState(false);

  const { user } = useContext(UserContext);


  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (drawerRef.current && !drawerRef.current.contains(event.target)) {
        toggleMenu(); // Close the drawer if clicked outside
      }
    };
    if (isOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpen, toggleMenu]);

  return (
    <div css={{ zIndex: 20000 }}>
      {isOpen && (
        <div
          css={styles.overlay} // Overlay to block clicks on the content below
          onClick={toggleMenu} // Close the drawer when clicking on the overlay
        />
      )}
      <div
        ref={drawerRef}
        css={{
          ...styles.drawer,
          transform: isOpen ? "translateX(0)" : "translateX(-100%)",
          color: "black",
        }}
      >
        <div css={styles.header.container}>
          <div css={styles.header.toggleMenu}>
            <button onClick={toggleMenu} css={styles.closeButton}>
              <i data-feather="x" />
            </button>
          </div>
        </div>
        <nav css={styles.nav}>
          <div css={{ marginTop: 10 }}>
            {/* Header */}
            <MenuDrawerHeader isUserLogged={!user} />
            {/* Login */}
            {(!user || user?.isAnonymous === true) && <LoginComponent toggleMenu={toggleMenu} />}
            {/* My Account */}
            {user && user?.isAnonymous === false && <MyAccountComponent toggleMenu={toggleMenu} />}
            {/* Menu */}
            <ul css={styles.list}>
              {/**  Shop All */}
              <li
                css={styles.listingItem.container}
                onClick={() => {
                  // analytics
                  logAnalyticsEvent("menu_click", {
                    item: "Shop",
                    environment: environment,
                  });
                  toggleMenu();
                  navigate("/shop");
                }}
              >
                <p css={styles.listingItem.title}>Shop All</p>
                <p>
                  <ArrowForward css={styles.listingItem.icon} />
                </p>
              </li>
              {/**  Browse */}
              <li css={{ ...styles.listingItem.container, flexDirection: "column", alignItems: "flex-start", border: 0, paddingBottom: 0 }}>
                <p css={styles.listingItem.title}>Browse</p>
                <div
                  css={{
                    ...styles.listingItem.subItem.container,
                  }}
                >
                  <div
                    onClick={() => {
                      setToggleCategory(!toggleCategory);
                      setToggleEffect(false);
                    }}
                    css={{
                      ...styles.listingItem.subItem.item,
                    }}
                  >
                    <div>by Category</div>
                    {toggleCategory ? (
                      <KeyboardArrowUpOutlined
                        css={{
                          ...styles.listingItem.subItem.icon,
                        }}
                      />
                    ) : (
                      <KeyboardArrowDownOutlined
                        css={{
                          ...styles.listingItem.subItem.icon,
                        }}
                      />
                    )}
                  </div>
                  {toggleCategory && (
                    <div css={{ marginBottom: 20 }}>
                      <CategoryBrowse numColumns={3} title={false} containerStyles={{ padding: 0 }} shopButton={false} toggleMenu={toggleMenu} />
                    </div>
                  )}
                </div>
                <div
                  css={{
                    ...styles.listingItem.subItem.container,
                  }}
                >
                  <div
                    onClick={() => {
                      setToggleEffect(!toggleEffect);
                      setToggleCategory(false);
                    }}
                    css={{
                      ...styles.listingItem.subItem.item,
                    }}
                  >
                    <div>by Effect</div>
                    {toggleEffect ? (
                      <KeyboardArrowUpOutlined
                        css={{
                          ...styles.listingItem.subItem.icon,
                        }}
                      />
                    ) : (
                      <KeyboardArrowDownOutlined
                        css={{
                          ...styles.listingItem.subItem.icon,
                        }}
                      />
                    )}
                  </div>
                  {toggleEffect && (
                    <div css={{ marginBottom: 20 }}>
                      <FindYourVibe numColumns={2} title={false} containerStyles={{ padding: 0 }} shopButton={false} toggleMenu={toggleMenu} />
                    </div>
                  )}
                </div>
              </li>

              <li
                css={styles.listingItem.container}
                onClick={() => {
                  // analytics
                  logAnalyticsEvent("menu_click", {
                    item: "Account",
                    environment: environment,
                  });
                  toggleMenu();
                  navigate("/knowledge");
                }}
              >
                <p css={styles.listingItem.title}>Knowledge</p>
                <p>
                  <ArrowForward css={styles.listingItem.icon} />
                </p>
              </li>
              <li
                css={styles.listingItem.container}
                onClick={() => {
                  // analytics
                  logAnalyticsEvent("menu_click", {
                    item: "Knowledge",
                    environment: environment,
                  });
                  toggleMenu();
                  navigate("/help");
                }}
              >
                <p css={styles.listingItem.title}>Help</p>
                <p>
                  <ArrowForward css={styles.listingItem.icon} />
                </p>
              </li>

              <li
                css={styles.listingItem.container}
                onClick={() => {
                  // analytics
                  logAnalyticsEvent("menu_click", {
                    item: "Rewards",
                    environment: environment,
                  });
                  toggleMenu();
                  navigate("/rewards");
                }}
              >
                <p css={styles.listingItem.title}>Rewards</p>
                <p>
                  <ArrowForward css={styles.listingItem.icon} />
                </p>
              </li>
              <li
                css={styles.listingItem.container}
                onClick={() => {
                  // analytics
                  logAnalyticsEvent("menu_click", {
                    item: "Help",
                    environment: environment,
                  });
                  toggleMenu();
                  navigate("/about-us");
                }}
              >
                <p css={styles.listingItem.title}>About Us</p>
                <p>
                  <ArrowForward css={styles.listingItem.icon} />
                </p>
              </li>
            </ul>
          </div>
        </nav>
        <div css={{ textAlign: "left", fontSize: "8px", color: "silver", padding: 20, fontWeight: 200 }}>
          <p css={{ display: "none" }}>{user?.uid || ""}</p>
          <p css={{ color: "gray", fontSize: 10 }}>v1.7.0</p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  drawer: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    maxWidth: "400px",
    height: "100%",
    backgroundColor: "#fff",
    boxShadow: "2px 0 5px rgba(0, 0, 0, 0.1)",
    transition: "transform 0.3s ease",
    zIndex: 20000,
    overflowY: "auto",
    maxHeight: "100vh",
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0, 0.4)", // Semi-transparent overlay
    zIndex: 9999,
    pointerEvents: "auto",
  },
  header: {
    container: {},
    toggleMenu: {
      position: "absolute",
      top: 0,
      right: 0,
      textAlign: "right",
      cursor: "pointer",
      padding: "20px 15px",
    },
    userName: {
      fontSize: "24px",
      fontWeight: "600",
      margin: 0,
    },
    memberSince: {
      fontSize: "12px",
      textTransform: "uppercase",
      color: "rgb(150,150,150)",
      margin: 0,
    },
  },
  closeButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
    color: "black",
  },
  nav: {
    padding: "16px",
  },
  list: {
    listStyle: "none",
    padding: "5px 0 0 0",
  },
  listingItem: {
    container: {
      cursor: "pointer",
      padding: "15px 0",
      display: "flex",
      justifyContent: "space-between",
      borderBottom: "1px solid #B3B3B3",
    },
    subItem: {
      container: {
        width: "100%",
        fontWeight: "400",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        borderBottom: "1px solid #B3B3B3",
      },
      item: {
        width: "100%",
        padding: "10px 0px 10px 10px",
        fontWeight: "400",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
      },
      icon: {
        color: "gray",
        aspectRatio: "1",
        fontSize: "26px",
      },
    },
    icon: {
      color: "black",
      aspectRatio: "1",
      height: "18px",
    },
  },
};
